import { render, staticRenderFns } from "./ParallaxImage.vue?vue&type=template&id=5c2f4286&scoped=true&"
import script from "./ParallaxImage.vue?vue&type=script&lang=js&"
export * from "./ParallaxImage.vue?vue&type=script&lang=js&"
import style0 from "./ParallaxImage.vue?vue&type=style&index=0&id=5c2f4286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2f4286",
  null
  
)

export default component.exports